export default __webpack_public_path__ + "media/95fd6b730bbf7ca4bf25d62489bebb66.png";